import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const DISCHARGE_REASONS = {
  no_longer_requires: "Patient no longer requires personal care services",
  different_level_of_care: "Patient's medical condition requires a different level or setting of care",
  admitted_to_facility: "Patient admitted to hospital, skilled nursing facility, hospice, or other facility",
  patient_requested: "Patient/representative requested discharge",
  goals_met: "Goals of care have been met",
  other: "Other",
  // legacy values still on older orders
  unable_to_provide_care: "Agency unable to provide required care (non-emergent change/inability to staff/non-payment)",
  safety_compromised: "Safety of PCW or nurse supervisor is compromised",
  benefit_abuse: "Client abusing/misusing personal care benefit",
};

const OPTIONS = ["no_longer_requires", "different_level_of_care", "admitted_to_facility", "patient_requested", "goals_met", "other"];

export const EMPTY_DISCHARGE = {
  discharge_reason: "",
  discharge_reason_other: "",
  discharge_date: "",
  discharge_last_service_date: "",
  discharge_instructions: "",
};

// Fields mirroring the paper "Physician Discharge Order" form
export function DischargeOrderFields({ value, onChange, idPrefix = "discharge" }) {
  const v = { ...EMPTY_DISCHARGE, ...(value || {}) };
  const set = (patch) => onChange({ ...v, ...patch });
  return (
    <div className="space-y-3 p-4 bg-red-50 rounded-lg" data-testid={`${idPrefix}-fields`}>
      <h4 className="text-sm font-medium text-red-800">Discharge Order Details</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-date`}>Effective Discharge Date</Label>
          <Input
            id={`${idPrefix}-date`}
            type="date"
            value={v.discharge_date}
            onChange={(e) => set({ discharge_date: e.target.value })}
            data-testid={`${idPrefix}-date`}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-last-service`}>Last Date of Service</Label>
          <Input
            id={`${idPrefix}-last-service`}
            type="date"
            value={v.discharge_last_service_date}
            onChange={(e) => set({ discharge_last_service_date: e.target.value })}
            data-testid={`${idPrefix}-last-service`}
          />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label>Reason for Discharge</Label>
        <Select value={v.discharge_reason} onValueChange={(val) => set({ discharge_reason: val })}>
          <SelectTrigger data-testid={`${idPrefix}-reason`}>
            <SelectValue placeholder="Select reason" />
          </SelectTrigger>
          <SelectContent>
            {OPTIONS.map((k) => (
              <SelectItem key={k} value={k}>{DISCHARGE_REASONS[k]}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {(v.discharge_reason === "other" || (v.discharge_reason && !OPTIONS.includes(v.discharge_reason))) && (
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-other`}>Other reason</Label>
          <Input
            id={`${idPrefix}-other`}
            value={v.discharge_reason_other}
            onChange={(e) => set({ discharge_reason_other: e.target.value })}
            placeholder="Describe the reason"
            data-testid={`${idPrefix}-other`}
          />
        </div>
      )}
      <div className="space-y-1.5">
        <Label htmlFor={`${idPrefix}-instructions`}>Additional Physician Instructions / Follow-Up</Label>
        <Textarea
          id={`${idPrefix}-instructions`}
          value={v.discharge_instructions}
          onChange={(e) => set({ discharge_instructions: e.target.value })}
          placeholder="Follow-up appointments, referrals, home instructions..."
          rows={3}
          data-testid={`${idPrefix}-instructions`}
        />
      </div>
    </div>
  );
}
